import Display from "../types/Display"
import formatPrice from "./formatPrice"

export interface CurrencyFormat {
    name: string
    prefix: string
    suffix: string
    decimalPoint: string
    thousandsSeparator: string
    decimalDigits: string
    uri: string
}

interface TransformedData {
    displays: Display[]
}

export const formatPricesInTransformedData = (
    transformedData: TransformedData,
    currentPricelist: CurrencyFormat | undefined
) => {
    const formattedDisplays = transformedData.displays.map((display: any) => {
        const formattedVariantDisplays = display.variant_displays.map((variant: any) => {
            const fallbackCurrencySuffix = variant?.currency
            return {
                ...variant,
                price_as_number: parseFloat(variant.sale_price),
                sale_price: formatPrice(
                    variant.sale_price.toString(),
                    currentPricelist,
                    fallbackCurrencySuffix
                ),
                original_price: formatPrice(
                    variant.original_price.toString(),
                    currentPricelist,
                    fallbackCurrencySuffix
                )
            }
        })

        return {
            ...display,
            variant_displays: formattedVariantDisplays
        }
    })

    return {
        ...transformedData,
        displays: formattedDisplays
    }
}
